export interface SchoolDTO {
  id: string;
  name: string;
  address?: string;
  phone?: string;
  email?: string;
  enabled?: boolean;
}

let selectedSchool: SchoolDTO | null = null;

export const stateService = {
  setSelectedSchool: (school: SchoolDTO | null): void => {
    selectedSchool = school;
  },
  getSelectedSchool: (): SchoolDTO | null => selectedSchool,
};
